export default "__VITE_ASSET__wtR3p5kV__"